import { createGetFlags } from '@happykit/flags/server'
import { happykitConfig } from './config'

export const getFlags = createGetFlags(happykitConfig)
